// extracted by mini-css-extract-plugin
export var actionButtonContainer = "Recipes-module--actionButtonContainer--Ff8e5";
export var container = "Recipes-module--container--8DOGe";
export var content = "Recipes-module--content--aSjPv";
export var found = "Recipes-module--found--FdW0h";
export var noItems = "Recipes-module--noItems--cNXWX";
export var noSuppliers = "Recipes-module--noSuppliers--BmOGo";
export var noteOrderStatus = "Recipes-module--noteOrderStatus--OOcdK";
export var notfound = "Recipes-module--notfound--KY8sX";
export var subHeader = "Recipes-module--subHeader--T2h-U";